import { first, indexOf, isNil } from 'lodash';

export default {
  methods: {
    autoAddNewRows(newVal, emptyRecord, isRecordEmpty = it => isNil(it)) {
      if (newVal.filter(it => isRecordEmpty(it)).length === 0) {
        newVal.push(emptyRecord);
      } else if (newVal.filter(it => isRecordEmpty(it)).length > 1) {
        const toDelete = first(newVal.filter(it => isRecordEmpty(it)));
        newVal.splice(indexOf(newVal, toDelete), 1);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/AutoAddNewRowsMixin.js